class AxiosUtil {
	/**
	 * Since it's a static, utilitary class, it can not be instantiated.
	 */
	constructor() {
		throw new Error("This class can't be instantiated.");
	}

	static handleError(logMessage, error) {
		const normalizedError = error?.response ? error.response?.data?.error : error;
		console.error(logMessage || 'handleError', normalizedError);
		throw normalizedError;
	}
}

export default AxiosUtil;
